// extracted by mini-css-extract-plugin
export default {"terms":"TermsAndConditions_terms__bvvI5"};